module.exports = __webpack_public_path__ + "static/media/online.584961b3.svg";